import { Component, OnInit } from '@angular/core';
import { ActivatedRoute} from '@angular/router';
import { UserService } from 'src/app/services/apiCalls/userService/user.service';
import { BootstrapNotifyService } from 'src/app/services/bootstrap-notify/bootstrap-notify.service';
import { NavigatorService } from 'src/app/services/navigatorService/navigator.service';


type ticketType = 'Traders' | 'Transport';
type ticketValidity = 'valid' | 'not-valid' | 'not-found';
@Component({
  selector: 'app-ticketing',
  templateUrl: './ticketing.component.html',
  styleUrl: './ticketing.component.css'
})
export class TicketingComponent implements OnInit {
  currentTicketId: string = '';
  loadingTicket: boolean = false;
  ticketingInfo: {} = {};
  isTicketValid: ticketValidity = 'not-valid';
  category: ticketType = 'Traders';
  constructor(
    private activatedRoute : ActivatedRoute, 
    private navigatorService: NavigatorService,
    private userService: UserService,
    private alertService: BootstrapNotifyService
  ){}
  ngOnInit(): void {
    const ticketId = this.activatedRoute.snapshot.params['ticketId'];
    if(!ticketId){
      this.navigatorService.navigateUrl('login');
      return;
    }
    this.currentTicketId = ticketId;
    this.getTicketByID(this.currentTicketId);
  }

  getTicketByID(id: string){
    this.loadingTicket = true;
    this.userService.validateTicketToken(id).subscribe({
      next: (response)=>{
        this.isTicketValid = 'valid';
        const {operator_category, issued_at} = response;
        if(operator_category === 'market'){
          this.category = 'Traders'
        }else{
          this.category = 'Transport'
        }
        const validDate = new Date(issued_at).toLocaleDateString('en-US',{
          year: 'numeric',
          month: 'long',
          day: 'numeric',
          hour: 'numeric',
          minute: 'numeric'
        });
        this.ticketingInfo = response;
        this.ticketingInfo['issued_at'] = validDate;
      },
      error: (error)=>{
        const {reason, operator_category, issued_at} = error.error.data;
        this.alertService.error(error.error.message);
        if(reason === 'expired_not_today'){
          this.isTicketValid = 'not-valid';
        if(operator_category === 'market'){
          this.category = 'Traders'
        }else{
          this.category = 'Transport'
        }
        const validDate = new Date(issued_at).toLocaleDateString('en-US',{
          year: 'numeric',
          month: 'long',
          day: 'numeric',
          hour: 'numeric',
          minute: 'numeric'
        });
        this.ticketingInfo = error.error.data;
        this.ticketingInfo['issued_at'] = validDate;
        }else{
          this.isTicketValid = 'not-found';
          this.alertService.error('Ticket not found');
        }
      }
    }).add(()=> this.loadingTicket = false)
}
}
